'use strict';
const FluxConstant = require('flux-constant');


module.exports = FluxConstant.set([
    'CREATE_NEW',
    'CREATE_NEW_RESPONSE',
    'GET_CLIENT_LOT_RESULTS',
    'GET_CLIENT_LOT_RESULTS_RESPONSE',
    'GET_LOT_RESULTS',
    'GET_LOT_RESULTS_RESPONSE',
    'HIDE_CREATE_NEW',
    'HIDE_CREATE_NEW_MAP',
    'HIDE_TERMS_MODAL',
    'SHOW_CREATE_NEW',
    'SHOW_CREATE_NEW_MAP',
    'SHOW_TERMS_MODAL',
    'UPDATE_LOT_STATUS',
    'UPDATE_LOT_STATUS_RESPONSE',
    'UPDATE_OCCUPANCY',
    'UPDATE_OCCUPANCY_RESPONSE',
    'GET_SUMMARY',
    'GET_SUMMARY_RESPONSE',
    'UPDATE_MAP_CENTER',
    'GET_BUS_TIMING',
    'GET_BUS_TIMING_RESPONSE',
    'SHOW_BUS_TIMING',
    'HIDE_BUS_TIMING',
    'GET_BIKE_TIMING',
    'GET_BIKE_TIMING_RESPONSE',
    'GET_LOT_MESSAGE',
    'GET_LOT_MESSAGE_RESPONSE',
    'GET_OVERLAY_IMAGE',
    'GET_OVERLAY_IMAGE_RESPONSE',
    'UPDATE_OVERLAY_LOAD'
]);



// WEBPACK FOOTER //
// client/pages/main/lots/constants.js